/* Copyright (C) 2022 ev-i Informationstechnologie GmbH */

let uidCounter = 0;

export function useIdGenerator(): (name: string) => string {
    const uid = uidCounter++;
    // start with cuid to prevent collisions with vue-unique-id
    return (name) => `cuid-${uid}-${name}`;
}
